export const getTypeSaml = (type) => {
  if (type && type.match(/^([a-z]|\d)+$/) !== null) return type;

  return null;
};
